import { measureLatency } from '../../gctl-measure';
import { NetworkError, deepCamelCase } from '../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetMeChannelFields = readonly string[];

/** Options for GET /me/channels/{channel_id} */
export type GetMeChannelOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the channel.
     */
    channelId: number;
  };
};

/** Result type for GET /me/channels/{channel_id} */
export type GetMeChannelResult<Paths extends readonly string[]> = unknown;

/**
 * Check if a user follows a channel
 * This method determines whether the specified user is a follower of a particular channel.
 */
export async function getMeChannel<Paths extends GetMeChannelFields>({
  baseUrl,
  where: { channelId },
  ...options
}: GetMeChannelOptions<Paths>): Promise<GetMeChannelResult<Paths>> {
  return measureLatency('getMeChannel', 'GET', async () => {
    let res = await fetch(`${baseUrl}/me/channels/${channelId}`, {
      ...options,
      method: 'GET',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as GetMeChannelResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}

export type PutMeChannelFields = readonly string[];

/** Options for PUT /me/channels/{channel_id} */
export type PutMeChannelOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the channel.
     */
    channelId: number;
  };
};

/** Result type for PUT /me/channels/{channel_id} */
export type PutMeChannelResult<Paths extends readonly string[]> = unknown;

/**
 * Subscribe the user to a specific channel
 * This method subscribes the authenticated user to the specified channel.
 */
export async function putMeChannel<Paths extends PutMeChannelFields>({
  baseUrl,
  where: { channelId },
  ...options
}: PutMeChannelOptions<Paths>): Promise<PutMeChannelResult<Paths>> {
  return measureLatency('putMeChannel', 'PUT', async () => {
    let res = await fetch(`${baseUrl}/me/channels/${channelId}`, {
      ...options,
      method: 'PUT',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as PutMeChannelResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}

export type DeleteMeChannelFields = readonly string[];

/** Options for DELETE /me/channels/{channel_id} */
export type DeleteMeChannelOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the channel.
     */
    channelId: number;
  };
};

/** Result type for DELETE /me/channels/{channel_id} */
export type DeleteMeChannelResult<Paths extends readonly string[]> = unknown;

/**
 * Unsubscribe the user from a specific channel
 * This method unsubscribes the authenticated user from the specified channel.
 */
export async function deleteMeChannel<Paths extends DeleteMeChannelFields>({
  baseUrl,
  where: { channelId },
  ...options
}: DeleteMeChannelOptions<Paths>): Promise<DeleteMeChannelResult<Paths>> {
  return measureLatency('deleteMeChannel', 'DELETE', async () => {
    let res = await fetch(`${baseUrl}/me/channels/${channelId}`, {
      ...options,
      method: 'DELETE',
    });

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as DeleteMeChannelResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
